interface TokenPayload {
  id: number;
  role: string;
  email: string;
}

function decodeToken(): TokenPayload | null {
  try {
    const token = localStorage.getItem("jwtToken");
    if (!token) return null;

    const payloadBase64 = token.split(".")[1];
    if (!payloadBase64) return null;

    // Base64url → Base64 → JSON
    const base64 = payloadBase64.replace(/-/g, "+").replace(/_/g, "/");
    const jsonStr = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    const payload = JSON.parse(jsonStr);
    return {
      id: payload.id,
      role: payload.role,
      email: payload.email,
    };
  } catch {
    return null;
  }
}

/** Returns the logged-in user's numeric ID as a string, or "" if unavailable. */
export function getUserId(): string {
  return decodeToken()?.id?.toString() ?? "";
}

/** Returns the logged-in user's role, or "" if unavailable. */
export function getUserRole(): string {
  return decodeToken()?.role ?? "";
}

/** Returns the logged-in user's email, or "" if unavailable. */
export function getUserEmail(): string {
  return decodeToken()?.email ?? "";
}

/** Returns all three fields at once — use when you need more than one. */
export function getTokenPayload(): TokenPayload | null {
  return decodeToken();
}
